import type { RouteObject } from "react-router-dom";
import { lazy } from "react";
import ProtectedRoute from "../components/auth/ProtectedRoute";

const Home = lazy(() => import("../pages/home/page"));
const Dashboard = lazy(() => import("../pages/dashboard/page"));
const MealPlans = lazy(() => import("../pages/meal-plans/page"));
const Recipes = lazy(() => import("../pages/recipes/page"));
const Nutrition = lazy(() => import("../pages/nutrition/page"));
const Grocery = lazy(() => import("../pages/grocery/page"));
const LoginPage = lazy(() => import("../pages/auth/LoginPage"));
const RegisterPage = lazy(() => import("../pages/auth/RegisterPage"));
const NotFound = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/meal-plans",
    element: (
      <ProtectedRoute>
        <MealPlans />
      </ProtectedRoute>
    ),
  },
  {
    path: "/recipes",
    element: (
      <ProtectedRoute>
        <Recipes />
      </ProtectedRoute>
    ),
  },
  {
    path: "/nutrition",
    element: (
      <ProtectedRoute>
        <Nutrition />
      </ProtectedRoute>
    ),
  },
  {
    path: "/grocery",
    element: (
      <ProtectedRoute>
        <Grocery />
      </ProtectedRoute>
    ),
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/register",
    element: <RegisterPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
